<aside class="home-aside" style="min-width:14rem;padding:0 var(--wa-spacing-large) var(--wa-spacing-large) var(--wa-spacing-large);position:sticky;top:var(--wa-spacing-large);">
	<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>On this page</div>
	<ul style="display:flex;flex-direction:column;gap:var(--wa-spacing-x-small);list-style:none;margin:var(--wa-spacing-small) 0 0 0;padding:0;">
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('hero').scrollIntoView({behavior:'smooth'})">Overview</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('why-jwebmp').scrollIntoView({behavior:'smooth'})">Why JWebMP</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('component-ecosystem').scrollIntoView({behavior:'smooth'})">Plugins</a>
		</li>
	</ul>
</aside>